const defaultState = {
  user_challenges: [],
  challenge_details: {},
  challenge_entries: [],
  challenge_button: false
};

const challengesReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_USER_CHALLENGES": {
      return {
        ...state,
        user_challenges: action.data
      };
    }
    case "SET_CHALLENGE_DETAILS": {
      return {
        ...state,
        challenge_details: action.data
      };
    }
    case "SET_CHALLENGE_ENTRIES": {
      return {
        ...state,
        challenge_entries: action.data
      };
    }
    case "SET_CHALLENGE_BUTTON": {
      return {
        ...state,
        challenge_button: action.data
      };
    }
    default:
      return state;
  }
};

export default challengesReducer;
